module.exports = __webpack_public_path__ + "img/icon_tel.1da453e0.png";